<template>
    <div class="tile-content position-relative">
        <div class="tile-subtitle">
            <h3>Additional criteria</h3>
        </div>
        <div class="stack-m">
            <condition-builder
                inline
                :criteria="additionalCriteria"
                :event="additionalCriteriaEvent"
                @update="triggerUpdate"
            />
        </div>
    </div>
</template>
<script>
    import vInlineLoader from '@/components/v-inline-loader';
    import ConditionBuilder from '@/modules/rules-engine/components/condition-builder/condition-builder';
    import additionalCriteriaEvent from '@/modules/gateway-accounts/components/details/additional-criteria-event';
    import CriteriaCondition from '@/components/query/spec/criteria-condition';

    export default {
        name: 'gateway-additional-criteria-input',
        components: {
            vInlineLoader,
            ConditionBuilder,
        },
        props: {
            value: {
                type: CriteriaCondition,
            },
        },
        data() {
            return {
                additionalCriteria: this.value,
                additionalCriteriaEvent,
            };
        },
        methods: {
            triggerUpdate(additionalCriteria) {
                this.additionalCriteria = additionalCriteria;
                this.$emit('input', additionalCriteria);
            },
        },
    };
</script>
